
export const apiConstants = {
  url: "/api/event",
  eventCategories: "/api/eventcategory",
};
